export const DELEGATION_TYPE_CODE = {
  US_OTC_AOTC_PREVENTATIVE: "US_OTC_AOTC_PREVENTATIVE",
  US_OTC_AOTC_PREVENTATIVE_RX: "US_OTC_AOTC_PREVENTATIVE_RX",
  US_OTC_AOTC_PREVENTATIVE_RX_DM: "US_OTC_AOTC_PREVENTATIVE_RX_DM",
};

export const PRACTICE_USER_TYPE_CODE = {
  VETERINARIAN: "VETERINARIAN",
};
